




























































































































































import { Component, Mixins } from "vue-property-decorator";

/**
 * Utils
 */
import { getTimeSince } from "@/utils/date-helpers";
import classes from "@/config/wow/classes";
import factions from "@/config/wow/factions";
import * as imageLinks from "@/config/image-links";
import itemClasses from "@/config/wow/item-classes";


import difficulties from "@/config/wow/difficulties";

import { sortByAsc } from "@/utils/sort-helpers";

const groupBy = (key: string) => {
	return (array: any[]) => {
		return array.reduce((objectsByKeyValue, obj) => {
			const value = obj[key];
			objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
			return objectsByKeyValue;
		}, {});
	};
};

const groupByClass = groupBy("class");
//&bonus=${l.bonus + difficulties[activeDifficultyIndex].val}

/**
 * Components
 */
import LootCard from "./components/LootCard.vue";
import DataFetcher from "@/components/_global/DataFetcher.vue";

/**
 * API
 */
import charactersAPI from "@/api/characters";
import raidsAPI from "@/api/raids";
import teamsAPI from "@/api/teams";

/**
 * Types
 */


/**
 * Mixins
 */
import mixinNow from "@/mixins/now-mixin";
import { Guid } from "@/domain/guid";
import { GetRaidsResponse } from "@/api/raids/get-raids.response";
import { GetOneCharacterWishesResponse } from "@/api/characters/get-one-character-wishes.response";
import { SaveOneCharacterWishesRequest } from "@/api/characters/save-one-character-wishes.request";
import { GetTeamsResponse } from "@/api/teams/get-teams.response";
import { GetOneCharacterResponse } from "@/api/characters/get-one-character.response";


/**
 * Character wishes editor page.
 */
@Component({
	components: {
		DataFetcher,
		LootCard
	}
})
export default class WishesEditorPage extends Mixins(mixinNow) {
	/// Injections
	classes = classes;
	factions = factions;
	imageLinks = imageLinks;
	difficulties = difficulties;
	itemClasses = itemClasses;

	getTimeSince = getTimeSince;

	/// Attributes
	isLoading = false;
	hasUnsavedChanges = false;
	character: GetOneCharacterResponse | null = null;
	lastLootWishesUpdateTime: Date | null = null;
	characterWishes: GetOneCharacterWishesResponse.Wish[] | null = null;
	characterWishesToSend: SaveOneCharacterWishesRequest.Wish[] = [];
	raids: GetRaidsResponse.Raid[] | null = null;
	teams: GetTeamsResponse.Team[] | null = null;

	teamsSharedWith: Guid[] | null = null;

	filterItemsByClass = true;

	activeRaidID: Guid | null = null;
	activeBossID: Guid | null = null;
	activeDifficultyIndex = 0;


	get activeRaidBosses(): GetRaidsResponse.Boss[] | null {
		if (this.raids == null) {
			return null;
		}

		const activeRaid = this.raids.find((x) => x.id === this.activeRaidID) ?? null;
		if (activeRaid == null) {
			return null;
		}
		return activeRaid.bosses;
	}

	get activeBossLoots() {
		const character = this.character;
		if (character == null) {
			return null;
		}

		if (this.activeRaidBosses == null) {
			return null;
		}
		const activeBoss = this.activeRaidBosses.find((x) => x.id === this.activeBossID) ?? null;
		if (activeBoss == null) {
			return null;
		}

		let loots = activeBoss.loots;
		if (this.filterItemsByClass) {
			loots = loots.filter(x => {
				const allowableClasses = x.allowableClasses != null ? JSON.parse(x.allowableClasses) : null;
				if (allowableClasses && allowableClasses.length > 0) {
					return allowableClasses.includes(character.class);
				}

				const itemClassesRules = classes[character.class].itemClasses;
				if (itemClassesRules.hasOwnProperty(x.class)) {
					return itemClassesRules[x.class].includes(x.subClass);
				}

				return true;
			});
		}

		return groupByClass(
			loots.sort(sortByAsc(x => x.slot))
				.sort(sortByAsc(x => x.class))
		);
	}


	get canSave() {
		return !this.isLoading && this.hasUnsavedChanges;
	}

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchCurrentCharacter();
		this.teams = await teamsAPI.getTeams();
		this.raids = await raidsAPI.fetchRaids();
		if (this.raids && this.raids.length > 0) {
			this.activeRaidID = this.raids[0].id;
		}
	}

	async secondaryFetch() {
		await this.fetchCurrentCharacter();
	}

	async fetchCurrentCharacter() {
		const characterID = this.$route.params.id;
		await this.fetchCharacter(characterID);
	}

	async fetchCharacter(id: Guid) {
		this.character = await charactersAPI.fetchCharacter(id);
		const {
			lastLootWishesUpdateTime,
			wishes,
			teamsSharedWith
		} = await charactersAPI.fetchWishes(id);

		this.lastLootWishesUpdateTime = lastLootWishesUpdateTime ? new Date(Date.parse(lastLootWishesUpdateTime)) : null;
		this.characterWishes = wishes;
		this.teamsSharedWith = teamsSharedWith;
		this.hasUnsavedChanges = false;
	}

	async handleSaveClick() {
		if (this.character == null) {
			return;
		}
		this.isLoading = true;
		try {
			await charactersAPI.saveWishes(this.$route.params.id, this.characterWishesToSend);
			await this.fetchCurrentCharacter();
			this.characterWishesToSend = [];
			this.$snackbar.openInfo(this.$t("snackbar.save_success"));
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	private setWishValueElement(lootID: Guid, f: (x: SaveOneCharacterWishesRequest.Wish) => void) {
		if (this.characterWishes == null) {
			return;
		}

		const defaultWish = {
			value: 0,
			difficulty: 0,
			note: null
		};

		const existingWish = this.characterWishes.find(w => w.lootID === lootID) ?? null;
		const existingWishToSend = this.characterWishesToSend.find(w => w.lootID === lootID) ?? null;

		if (existingWishToSend == null) {
			const newElement: SaveOneCharacterWishesRequest.Wish = {
				...(existingWish ?? defaultWish),
				lootID: lootID,
			};
			f(newElement);
			this.characterWishesToSend.push(newElement);
		}
		else {
			f(existingWishToSend);
		}
		if (existingWish == null) {
			const newElement = {
				...defaultWish,
				lootID: lootID
			};
			f(newElement);
			this.characterWishes.push(newElement);
		}
		else {
			f(existingWish);
		}

		this.hasUnsavedChanges = true;
	}

	handleRateLoot(lootID: Guid, value: number) {
		this.setWishValueElement(lootID, (w) => w.value = value);
	}

	handleEditNoteLoot(lootID: Guid, note: string) {
		this.setWishValueElement(lootID, (w) => w.note = note);
	}

	handleEditDifficultyLoot(lootID: Guid, difficulty: number | null) {
		this.setWishValueElement(lootID, (w) => w.difficulty = (difficulty != null ? difficulty : 0));
	}

	isTeamChecked(teamID: Guid) {
		return this.teamsSharedWith != null && this.teamsSharedWith.includes(teamID);
	}

	async handleCheckTeam(teamID: Guid, isChecked: boolean) {
		if (this.teamsSharedWith == null) {
			return;
		}
		const characterID = this.$route.params.id;

		if (isChecked) {
			this.teamsSharedWith = [...this.teamsSharedWith, teamID];
		}
		else {
			this.teamsSharedWith = this.teamsSharedWith.filter(x => x != teamID);
		}

		this.isLoading = true;
		try {
			const payload = [{
				id: teamID,
				shared: isChecked
			}];

			await charactersAPI.shareWishlistWithTeam(characterID, payload);

			const {
				teamsSharedWith
			} = await charactersAPI.fetchWishes(characterID);

			this.teamsSharedWith = teamsSharedWith;
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
